const initialState = {
  isCustomiserOpen: false,
};

export default initialState;
